import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Home from '../views/Home.vue'
import MerchantLogin from '../views/MerchantLogin.vue'
import AdminLogin from '../views/AdminLogin.vue'
import MerchantDashboard from '../views/merchant/Dashboard.vue'
import MerchantProducts from '../views/merchant/Products.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import Profile from '../views/Profile.vue'
import Cart from '../views/Cart.vue'
import Orders from '../views/Orders.vue'
import Payment from '../views/Payment.vue'
import ProductDetail from '../views/ProductDetail.vue'

const getPortalHome = (portalRole) => {
  if (portalRole === 'MERCHANT') return '/merchant'
  if (portalRole === 'ADMIN') return '/admin'
  return '/home'
}

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/merchant/login',
    name: 'MerchantLogin',
    component: MerchantLogin
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/merchant',
    name: 'MerchantDashboard',
    component: MerchantDashboard,
    meta: { requiresAuth: true, portalRole: 'MERCHANT' }
  },
  {
    path: '/merchant/products',
    name: 'MerchantProducts',
    component: MerchantProducts,
    meta: { requiresAuth: true, portalRole: 'MERCHANT' }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, portalRole: 'ADMIN' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, portalRole: 'USER' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: { requiresAuth: true }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫：保护需要登录的页面
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const portalRole = localStorage.getItem('portalRole') || 'USER'
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiredPortal = to.matched.find(record => record.meta.portalRole)?.meta.portalRole
  const isAuthPage = ['/login', '/register', '/merchant/login', '/admin/login'].includes(to.path)
  
  if (requiresAuth && !token) {
    if (requiredPortal === 'MERCHANT') return next('/merchant/login')
    if (requiredPortal === 'ADMIN') return next('/admin/login')
    return next('/login')
  }

  if (token && isAuthPage) {
    return next(getPortalHome(portalRole))
  }

  if (token && requiredPortal && requiredPortal !== portalRole) {
    return next(getPortalHome(portalRole))
  }

  next()
})

export default router